<template>
  <van-list
    style="height: height; overflow: auto"
    :finished="finished"
    :loading-text="'加载中...'"
    :finished-text="'已显示全部'"
    @load="onLoad"
    v-model="loading"
    :error="error"
    :error-click="search"
  >
    <slot></slot>
  </van-list>
</template>
<script name="scrollList">
export default {
  name: "scrollList",
  props: {
    height: {
      type: String,
      default: "calc(100vh - 200px)",
    },
    finished: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onLoad() {
      this.$emit("load");
    },
    search() {
      this.$emit("search");
    },
  },
};
</script>
<style lang="less" scoped></style>
